import React, { Component } from 'react'
import c from 'classnames'
import PropTypes from 'prop-types'
import Image from 'src/components/image'
import backgroundSrc from 'src/assets/phone-background.png'
import loaderSrc from 'src/assets/phone-loader.svg'

export class PhoneContainer extends Component {
  static propTypes = {
    className: PropTypes.string,
    src: PropTypes.any,
    alt: PropTypes.string,
    delay: PropTypes.number,
    forceIndex: PropTypes.number,
    showBackground: PropTypes.bool,
    showLoader: PropTypes.bool,
    children: PropTypes.any,
  }

  static defaultProps = {
    className: '',
    src: '',
    alt: 'Phone Content',
    delay: 1500,
    forceIndex: null,
    showBackground: false,
    showLoader: false,
    children: null,
  }

  state = {
    index: 0,
  }

  get className() {
    const { className } = this.props
    return c('phone-container', className)
  }

  get sources() {
    const { src } = this.props
    return Array.isArray(src) ? src : [src]
  }

  componentDidMount = () => {
    this.mounted = true
    const { sources } = this
    const { delay } = this.props
    if (sources.length < 2) return
    const interval = setInterval(this.fade, delay)
    this.setState({ interval: interval })
  }

  fade = () => {
    if (!this.mounted) return
    const currentIndex = this.state.index
    const { sources } = this
    let nextIndex = currentIndex + 1
    if (nextIndex > sources.length - 1) nextIndex = 0
    this.setState({ index: nextIndex })
  }

  componentDidUpdate = prevProps => {
    const { forceIndex } = this.props
    if (typeof prevProps.forceIndex !== 'number' && typeof forceIndex === 'number') {
      clearInterval(this.state.interval)
      this.setState({ interval: null, index: forceIndex })
    }
    if (typeof prevProps.forceIndex === 'number' && typeof forceIndex !== 'number') {
      const { sources } = this
      const { delay } = this.props
      if (sources.length < 2) return
      const interval = setInterval(this.fade, delay)
      this.setState({ interval: interval })
    }
  }

  componentWillUnmount = () => {
    this.mounted = false
    clearInterval(this.state.interval)
  }

  render() {
    const { className, sources } = this
    const { alt, showBackground, showLoader, children } = this.props
    const { index } = this.state
    return (
      <div className={className}>
        {sources.map((src, i) => (
          <img
            key={`${i}-src`}
            className={c('device-content', index !== i && 'asset-hidden')}
            src={src}
            alt={alt}
          />
        ))}
        {showBackground && <Image className="background" src={backgroundSrc} alt="Phone Background" />}
        {showLoader && (
          <div className="loader">
            <Image className="loader-circle" src={loaderSrc} alt="Phone Loader" />
          </div>
        )}
        {children}
      </div>
    )
  }
}

export default PhoneContainer
